import { render, staticRenderFns } from "./SaveSchedule.vue?vue&type=template&id=67b7fcb7&scoped=true"
import script from "./SaveSchedule.vue?vue&type=script&lang=ts"
export * from "./SaveSchedule.vue?vue&type=script&lang=ts"
import style0 from "./SaveSchedule.vue?vue&type=style&index=0&id=67b7fcb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b7fcb7",
  null
  
)

export default component.exports